import React from 'react';
import './text-style.scss';

export interface ITextWithCadre {
  text: any;
  textColor: any;
  backgroundColor: any;
  icon: any;
}

export const TextBgColorWithCadre = ({ text, textColor, backgroundColor, icon }: ITextWithCadre) => {
  return <div style={{ borderColor: backgroundColor, backgroundColor, color: textColor }} className={'text-bg-color-whith-cadre justify-content-center text-bold d-flex align-items-center'}>
    {icon && <img className='icon-status' src={icon} />}
    <span className='text-status'>{text}</span>
  </div>;
};
